import { useEffect, useRef } from 'react';

export default function usePolling(callback, interval = 5000) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    callbackRef.current();

    const id = setInterval(() => {
      if (document.visibilityState !== 'hidden') {
        callbackRef.current();
      }
    }, interval);

    return () => clearInterval(id);
  }, [interval]);
}
